import React from 'react';
import { Modal, Button } from 'react-bootstrap';
import { useFetcher } from 'react-router-dom';
import { ProviderData } from '@/common/types';

interface Props {
  show: boolean;
  provider: ProviderData | null;
  onCancel: () => void;
  fetcher: ReturnType<typeof useFetcher>;
}

const ProviderDeleteModal: React.FC<Props> = ({
  show,
  provider,
  onCancel,
  fetcher,
}) => {
  return (
    <Modal show={show} onHide={onCancel} centered>
      <Modal.Header closeButton>
        <Modal.Title>Delete Provider</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        Are you sure you want to delete{' '}
        <strong>
          {provider?.firstName} {provider?.lastName}
        </strong>
        ?
        <p className="mt-2 mb-0">
          This can <strong>NOT</strong> be undone.
        </p>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onCancel}>
          Cancel
        </Button>
        <fetcher.Form
          method="delete"
          action={`/portal/providers/${provider?.id}/delete`}
          onSubmit={onCancel}
        >
          <Button variant="danger" type="submit">
            Delete
          </Button>
        </fetcher.Form>
      </Modal.Footer>
    </Modal>
  );
};

export default ProviderDeleteModal;
